import { Link } from "react-router-dom";
import { Layout } from "../components/Layout";

export default function NotFound() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-40 text-center" data-testid="notfound-page">
      <p className="eyebrow mb-4">404</p>
      <h1 className="text-4xl sm:text-5xl font-display font-extrabold text-white mb-4">Page not found</h1>
      <p className="text-slate-400 mb-8">The page you are looking for has moved or does not exist.</p>
      <Link to="/" className="btn-emerald px-6 py-3 rounded-full inline-block" data-testid="notfound-home-btn">
        Back to Home
      </Link>
    </div>
  );
}
